export default class Scroll {
  static scrollInViewElement(element, callback) {
    const threshold = 150
    const scrollIn = () => {
      const elementBottom = element.getBoundingClientRect().bottom
      if (elementBottom - threshold <= window.innerHeight) {
        callback(element)
        window.removeEventListener('load', scrollIn, false)
        window.removeEventListener('scroll', scrollIn, false)
      }
    }
    window.addEventListener('load', scrollIn, false)
    window.addEventListener('scroll', scrollIn, false)
  }
}
